package com.mshopsas.enterprise.aiw.scan.data.basket.ticket

import kotlinx.serialization.Serializable

@Serializable
data class Discount(
    val detail: String,
    val total: String,
)